/**
 * {@docCategory DocumentCard}
 */
export var DocumentCardType;
(function (DocumentCardType) {
  /**
   * Standard DocumentCard.
   */
  DocumentCardType[DocumentCardType["normal"] = 0] = "normal";
  /**
   * Compact layout. Displays the preview beside the details, rather than above.
   */
  DocumentCardType[DocumentCardType["compact"] = 1] = "compact";
})(DocumentCardType || (DocumentCardType = {}));